<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="ch00_fm06_dedi"></a><a id="page_v"></a>To Mom and Dad:<br/>Your love, challenge, encouragement,<br/>and prayers have marked me and<br/>my leadership forever.<br/>Thank you!<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_dedi.vue?c2ae98d4